import { useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Button from '@mui/material/Button';
import { useRadioCoverages } from '../../hooks/radioCoverage';

const RadioCoveragePopup = ({ marker }) => {
  const [transmission, setTransmission] = useState(marker.transmission || false);
  
  const {addRadioCoveragePosition} = useRadioCoverages();

  return (
    <Box sx={{ minWidth: 200, p: 1 }}>
      <Typography variant="subtitle2" gutterBottom>
        Ρυθμίσεις Εκπομπής {marker.name}
      </Typography>

      <FormControlLabel
        control={
          <Checkbox
            checked={transmission}
            onChange={(e) => setTransmission(e.target.checked)}
          />
        }
        label="Transmission"
      />

      <Box mt={1}>
        <Button variant="contained" size="small" onClick={() =>addRadioCoveragePosition(marker, transmission)}>
          Αποστολή
        </Button>
      </Box>
    </Box>
  );
};

export default RadioCoveragePopup;